import { Button, Col, Flex, Row, Typography } from 'antd';
import { FC } from 'react';

import { PageNodesAllAutocomplete } from '@/modules/Pages';

interface Props {
  siteId: string;
  choosenPageNodeId: string | undefined;
  isUrlInspectionLoading: boolean;
  errors: Record<string, string> | null;
  handleChangePageNodeId: (value: string | undefined) => void;
  handleResetResult: () => void;
  handleInspect: () => void;
}

export const SearchConsoleUrlInspectionFormView: FC<Props> = ({
  choosenPageNodeId,
  siteId,
  errors,
  isUrlInspectionLoading,
  handleChangePageNodeId,
  handleResetResult,
  handleInspect
}) => {
  return (
    <Row wrap gutter={ [0, 16] } style={{ width: '100%' }}>
      <Col span={ 24 }>
        <Flex wrap>
          <PageNodesAllAutocomplete
            disabled={ isUrlInspectionLoading }
            loading={ isUrlInspectionLoading }
            style={{ width: '100%' }}
            siteId={ siteId }
            value={ choosenPageNodeId }
            onChange={ handleChangePageNodeId }
            onClear={ handleResetResult }
          />
          { errors?.pageNodeId && <Typography.Text type="danger">{ errors.pageNodeId }</Typography.Text> }
        </Flex>
      </Col>

      <Col span={ 24 }>
        <Button
          onClick={ handleInspect }
          type="default"
          block
          disabled={ isUrlInspectionLoading }
          loading={ isUrlInspectionLoading }
        >
          Відправити
        </Button>
      </Col>
    </Row>
  );
};
